import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  inject,
} from '@angular/core';

import { Boxes } from 'src/app/models/Boxes.models';
import { OpenModalService } from 'src/app/services/shared/open-modal.service';

/**
 * Sub-modale "Modifica scatola" — apre quando l'utente clicca su una
 * scatola custom esistente dentro `<app-confirm-boxes>` per modificarne
 * le dimensioni.
 *
 * Restyle v2.11.1 (#5):
 *  - 🚨 Drop kendo-dialog wrapper → Diakonix backdrop + dialog.
 *  - 🚨 Drop massive dead code: `order`, `orderToUpdate`, `documents`,
 *    `boxes`, `boxini` (caricati via getOrder1 + getBox e MAI usati nel
 *    template), `orderBoxDetails`/`addBoxForm` FormGroup mai istanziate,
 *    `productsToCheck`/`stepCount`/`maxChild`/`clickedBox`/`detailsBox`/
 *    `boxDet`/`orderToCheck`/`text` field morti, `numbers`/`selectedNumber`
 *    mai bound, `back` URL mai usato.
 *  - 🚨 Drop `addDocumentsToBox` duplicato (la vera implementazione vive
 *    in `confirm-boxes.addDocumentsToBox` ed è quella richiamata dal
 *    template parent — qui era dead code residuo).
 *  - 🚨 Drop 4 console.log + Swal interno (parent confirm-boxes già
 *    fornisce feedback completo).
 *  - 🚨 Drop `chosenBox` field e check `box_type_id == -2` morto (in
 *    questo componente box_type_id è sempre -1 = custom, è proprio il
 *    suo unico scenario di apertura).
 *  - Switch a `inject()` + signatures pulite.
 */
@Component({
  selector: 'app-box-details',
  templateUrl: './box-details.component.html',
  styleUrls: ['./box-details.component.scss'],
  standalone: false,
})


export class BoxDetailsComponent implements OnInit {

  @Input() openBox = false;
  @Input() box!: Boxes.BoxOrder;
  @Input() boxNo!: number;
  @Output() dataInfo = new EventEmitter<object>();

  public readonly openModal = inject(OpenModalService);

  /** Form state, inizializzato dai valori della scatola passata. */
  public newBox!: Boxes.BoxOrder;

  ngOnInit(): void {
    this.newBox = new Boxes.BoxOrder(this.box);
  }

  goBack(): void {
    this.openModal.closeDetBox();
  }

  /** Bottone Salva disabled finché tutte le dimensioni sono valorizzate. */
  get isSaveDisabled(): boolean {
    return !this.newBox || this.newBox.checkForNull();
  }

  validateBox(): void {
    const payload = {
      custom: this.newBox,
      boxNo: this.boxNo,
    };
    this.dataInfo.emit(payload);
    this.openModal.closeBox(payload);
  }
  
}
